// extracted by mini-css-extract-plugin
export default {"spacer":"DataActions_spacer__u2xmm"};